import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type Parameter = {
    loadMoreDesignerProducts: boolean;
};

export const DispatchSetLoadMoreDesignerProducts: CustomApiHandler<Parameter, boolean> = props => {
    props.dispatch({
        type: "Custom/DesignerProducts/SetLoadMoreDesignerProducts",
        result: props.parameter.loadMoreDesignerProducts,
    });
};

export const chain = [DispatchSetLoadMoreDesignerProducts];

const loadMoreDesignerProducts = createHandlerChainRunner(chain, "LoadMoreDesignerProducts");
export default loadMoreDesignerProducts;
